var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoMsg v-video"},[_c('div',{on:{"click":function($event){return _vm.openVideo(_vm.data.filePath)}}},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":_vm.data.previewImageUrl}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c8e6079","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/ChatMessageVedio.vue
// module id = null
// module chunks = 